<p-toast key="newRequestErrors">
    <ng-template let-message pTemplate="message">
        <div>
            <h4>{{ message.summary | translate }}</h4>
            <p>{{ message.detail | translate }}</p>
            <ul *ngIf="message.data">
                <li *ngFor="let data of message.data">
                    <span class="material-symbols-outlined"> warning </span>
                    {{ data | translate }}
                </li>
            </ul>
        </div>
    </ng-template>
</p-toast>

<p-confirmDialog />

<div class="request-steps-header">
    <ul>
        <li [ngClass]="{ 'current': newRequestStatus.step === 1, 'done': newRequestStatus.step > 1 }">
            <span>1</span>
            <p>{{ "NEW_REQUEST.SUBTITLE_REQUEST" | translate }}</p>
        </li>
        <li [ngClass]="{ 'current': newRequestStatus.step === 2, 'done': newRequestStatus.step > 2 }">
            <span>2</span>
            <p>{{ "NEW_REQUEST.SUBTITLE_VALIDATION" | translate }}</p>
        </li>
        <li [ngClass]="{ 'current': newRequestStatus.step === 3, 'done': newRequestStatus.step > 3 }">
            <span>3</span>
            <p>{{ "NEW_REQUEST.REQUEST_SUMMARY" | translate }}</p>
        </li>
    </ul>
</div>

<div *ngIf="newRequestStatus.step === 1">
    <app-loading [isLoading]="isLoading" [messages]="waitingMessages">
        <h3 class="form-title">{{ "NEW_REQUEST.REQUEST_DATA" | translate }}</h3>
        <app-inside-disable [isDisabled]="formIsDisabled">
            <form [formGroup]="newCardRequestService.myForm" disabled>
                <div class="grid">
                    <div class="col-3" *ngIf="newCardRequestService.myForm.get('personId')">
                        <label for="_documentNumber">{{ 'NEW_REQUEST.ID_NUMBER_STANDARD' | translate }}</label>
                        <input pInputText id="_documentNumber" formControlName="personId" />
                    </div>

                    <div class="col-3" *ngIf="newCardRequestService.myForm.get('personIdExpirationDate')">
                        <label for="_expirationDate">{{ 'NEW_REQUEST.ID_EXPIRATION_DATE' | translate }}</label>
                        <p-datepicker id="_expirationDate" formControlName="personIdExpirationDate" dateFormat="dd/mm/yy"
                        [showIcon]="true" />
                    </div>

                    <div class="col-3" *ngIf="newCardRequestService.myForm.get('birthDate')">
                        <label for="_expirationDate">{{ 'NEW_REQUEST.BIRTH_DATE' | translate }}</label>
                        <p-datepicker id="_birthDate" formControlName="birthDate" dateFormat="dd/mm/yy"
                        [showIcon]="true" />
                    </div>

                    <div class="col-3" *ngIf="newCardRequestService.myForm.get('phoneNumber')">
                        <label for="_phone">{{ 'NEW_REQUEST.PHONE' | translate }}</label>
                        <input pInputText="_phone" formControlName="phoneNumber" />
                    </div>

                    <div class="col-3" *ngIf="newCardRequestService.myForm.get('documentationPack')">
                        <label for="_documentationPack">{{ 'NEW_REQUEST.DOC_PACK' | translate }}</label>
                        <p-select
                            #documentationPackDropdown
                            id="_documentationPack"
                            [options]="documentationPackValues"
                            [optionValue]="'packName'"
                            [optionLabel]="'packName'"
                            placeholder="{{ 'FILTER.SELECT' | translate }}"
                            formControlName="documentationPack"
                        >
                            <ng-template let-option pTemplate="item">
                                <div pTooltip="{{ option.packDescription }}" tooltipPosition="top">
                                    {{ option.packName }}
                                </div>
                            </ng-template>
                        </p-select>
                    </div>

                    <!-- *** BELENDER WIDGET LANG *** -->
                    <div class="col-5" *ngIf="newCardRequestService.myForm.get('language')">
                        <label for="language">{{ 'NEW_REQUEST.BELENDER_WIDGET_LANG' | translate }}</label>
                        <p-select
                            id="language"
                            [options]="belenderWidgetLangOptions"
                            optionValue="value"
                            optionLabel="label"
                            formControlName="language"
                        >
                            <ng-template let-option pTemplate="selectedItem">
                                <div>{{ option.label | translate }}</div>
                            </ng-template>
                            <ng-template let-option pTemplate="item">
                                <div>{{ option.label | translate }}</div>
                            </ng-template>
                        </p-select>
                    </div>
                </div>

                <app-admin-messages #adminMessages type="claveCards" (isOk)="isAdminOk = $event" />

                <div class="checkbox-row">
                    <p-checkbox
                        inputId="confirmSubmit"
                        [binary]="true"
                        [(ngModel)]="isConsentChecked"
                        [ngModelOptions]="{ standalone: true }"
                    ></p-checkbox>&nbsp;
                    <label for="confirmSubmit">{{ 'NEW_REQUEST.CHECK_CONSENT_CARDS' | translate }}</label>
                </div>

                <div class="buttons-row">
                    @if (isAdminOk) {
                        <button class="filled-btn" (click)="onSubmit()" [disabled]="!isConsentChecked">{{ 'NEW_REQUEST.CREATE_REQUEST' | translate }}</button>
                    } @else {
                        <button class="filled-btn" (click)="adminMessagesComponent.setMessages()">{{ 'NEW_REQUEST.CHECK_STATUS' | translate }}</button>
                    }
                </div>
            </form>
        </app-inside-disable>
    </app-loading>
</div>

<div *ngIf="newRequestStatus.step === 2">
    <div class="iframe-container">
        <app-inside-disable [isDisabled]="detailButtonIsVisible()">
            <div style="text-align: center;" *ngIf="trustedConsentUrlBoxed">
                <iframe width="600px" height="610px" [src]="trustedConsentUrlBoxed" frameborder="0"></iframe>
            </div>
        </app-inside-disable>
    </div>

    <div class="buttons-row" *ngIf="detailButtonIsVisible()">
        <button class="filled-btn" (click)="goToLastStep()" [disabled]="!physicalPersonQueryResponse && !newCardRequestService.isFinishingOTP">
            {{ "NEW_REQUEST.NEXT" | translate }}
        </button>
    </div>
</div>

<div *ngIf="newRequestStatus.step === 3">
    <app-loading [isLoading]="isLoadingRequest">
        <h3 class="form-title">{{ "NEW_REQUEST.REQUEST_SUMMARY" | translate }}</h3>
        <div class="grid form-inline label-W170">
            <div class="col-12 mb-1" *ngIf="this.newCardRequestService.myForm.get('personId')">
                <label for="_documentNumber">{{ "NEW_REQUEST.ID_NUMBER_STANDARD" | translate }}</label>
                <div class="read-only">
                    <span id="_documentNumber">{{ newCardRequestService.myForm.get("personId").value }}</span>
                </div>
            </div>

            <div class="col-12 mb-1" *ngIf="this.newCardRequestService.myForm.get('personIdExpirationDate')">
                <label for="_expirationDate">{{ "NEW_REQUEST.ID_EXPIRATION_DATE" | translate }}</label>
                <div class="read-only">
                    <span id="_expirationDate">{{ newCardRequestService.myForm.get("personIdExpirationDate").value | date:"dd/MM/yyyy" }}</span>
                </div>
            </div>

            <div class="col-12 mb-1" *ngIf="this.newCardRequestService.myForm.get('birthDate')">
                <label for="_birthDate">{{ "NEW_REQUEST.BIRTH_DATE" | translate }}</label>
                <div class="read-only">
                    <span id="_birthDate">{{ newCardRequestService.myForm.get("birthDate").value | date:"dd/MM/yyyy" }}</span>
                </div>
            </div>

            <div class="col-12 mb-1" *ngIf="this.newCardRequestService.myForm.get('phoneNumber')">
                <label for="_phone">{{ "NEW_REQUEST.PHONE" | translate }}</label>
                <div class="read-only">
                    <span id="_phone">{{ newCardRequestService.myForm.get("phoneNumber").value }}</span>
                </div>
            </div>

            <div class="col-12 mb-1" *ngIf="this.newCardRequestService.myForm.get('documentationPack')">
                <label for="_documentationPack">{{ "NEW_REQUEST.DOC_PACK" | translate }}</label>
                <div class="read-only">
                    <span id="_documentationPack">{{ newCardRequestService.myForm.get("documentationPack").value }}</span>
                </div>
            </div>
        </div>

        @if (physicalPersonQueryResponse.consentUrlBoxed) {
            <div class="center">
                <app-qr-code [value]="physicalPersonQueryResponse.consentUrlBoxed" [showLabel]="true" />
            </div>
        }

        <div class="info-box">
            <span class="material-symbols-outlined"> check_circle </span>
            <p>{{ getRequestValidationInfo() }}</p>
        </div>

        <div class="buttons-row">
            <button class="filled-btn" (click)="goToDetail()">{{ "NEW_REQUEST.DETAILS" | translate }}</button>
        </div>
    </app-loading>
</div>
